import type { InviteDto } from '@lagerfeuer/shared';
import { Users } from 'lucide-react';
import { ServerIcon } from '../shell/ServerIcon';

/** Vorschau einer Einladung: Banner, Icon, Name, Beschreibung, Mitgliederzahl. */
export function InvitePreview({ invite, compact }: { invite: InviteDto; compact?: boolean }) {
  const s = invite.server;
  return (
    <div className={`invite-preview ${compact ? 'compact' : ''}`} data-testid="invite-preview">
      {s.bannerUrl && !compact && <div className="invite-banner" style={{ backgroundImage: `url("${s.bannerUrl}")` }} aria-hidden="true" data-testid="invite-banner" />}
      <div className="invite-preview-body">
        <ServerIcon server={s} size={compact ? 48 : 72} />
        <div className="invite-preview-text">
          {invite.creator && !compact && <span className="muted small">Du wurdest eingeladen, beizutreten:</span>}
          <strong className="invite-server-name" data-testid="invite-server-name">
            {s.name}
          </strong>
          {s.description && !compact && <p className="invite-desc">{s.description}</p>}
          <span className="muted small row" style={{ gap: '0.3rem' }} data-testid="invite-member-count">
            <Users size={14} aria-hidden="true" />
            {s.memberCount.toLocaleString('de-DE')} {s.memberCount === 1 ? 'Mitglied' : 'Mitglieder'}
          </span>
        </div>
      </div>
    </div>
  );
}
